import React, { useState, useEffect, useRef } from "react";
import apiHelper from "../ApiHelpar/apiHelper";
import { SERCH_DOCOTOR_BU_NAME_MOBAILNO } from "../visitConstant/ApiConstant";
import useDebounce from "../useDebounce/useDebounce";
import UserSearchDropdown from "../CustomDropdown/UserSearchDropdown";

const DrSearchDropDown = ({
  onSelect,
  hospitalId = null,
  type = "branch",
  branchId = null,
}) => {
  const config = {
    displayKey: "name",
    placeholder: "Search doctors",
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasSelectedOnce, setHasSelectedOnce] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const debouncedSearchTerm = useDebounce(searchTerm, 700);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await apiHelper(SERCH_DOCOTOR_BU_NAME_MOBAILNO, {
        name: debouncedSearchTerm,
        hospitalId: hospitalId,
        branchId: branchId,
        offset: 0,
        pageSize: 10,
        activeStatus: true,
      });
      
console.log("api responnse", response);

      const searchResults = response?.respData?.respMsg || [];
          
      setOptions(searchResults);

      console.log(response, " searchResults");
    } catch (err) {
      const errorMessage =
        err instanceof Error ? err.message : "Failed to fetch doctors";
      setError(errorMessage);
      console.error("Search error:", err);
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  // Initial data fetch
  useEffect(() => {
    fetchData();
  }, [debouncedSearchTerm, hospitalId, branchId]);

  // Effect to select first item only on initial load
  useEffect(() => {
    if (!hasSelectedOnce && options && options.length > 0) {
      const firstItem = options[0];
      setSelectedItem(firstItem);
      onSelect(firstItem);
      setSearchTerm(firstItem[config.displayKey] || "");
      setHasSelectedOnce(true);
    }
  }, [options, hasSelectedOnce]);

  const handleInputChange = (value) => {
    setSearchTerm(value);
    // Don't reset the selected item when typing
  };

  const handleSelect = (item) => {
    if (item) {
      setSelectedItem(item);
      onSelect(item);
      setSearchTerm(item[config.displayKey] || "");
    } else if (!hasSelectedOnce && options.length > 0) {
      // If nothing is selected and this is the first time,
      // default to the first item
      const firstItem = options[0];
      setSelectedItem(firstItem);
      onSelect(firstItem);
      setSearchTerm(firstItem[config.displayKey] || "");
    } else if (selectedItem) {
      // If nothing new is selected but we have a previously selected item,
      // keep using that one
      onSelect(selectedItem);
    }
    setHasSelectedOnce(true);
  };

  const onAddNewItem=()=>{
return null
  }
  return (
    <div className="search-container">
      <UserSearchDropdown
        options={options}
        handleInputChange={handleInputChange}
        onSelect={handleSelect}
        value={searchTerm}
        loading={loading}
        Placeholder={config.placeholder}
        searchTerm={searchTerm}
        newEntry={true}
        UserSearchDrop={false}
        displayKey={(option) => option?.name || ""}
        onAddNewItem={onAddNewItem()}

      />

      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default DrSearchDropDown;
